import translate from '../../i18n'

type TranslationKey = Parameters<typeof translate>[0]

const statusTranslationKeys: Record<string, TranslationKey> = {
  PAID: 'orderHistories.status.paid',
  PENDING: 'orderHistories.status.pending',
  NEED_CUSTOMER_SERVICE: 'orderHistories.status.needCustomerService',
  FAILED: 'orderHistories.status.failed',
  CANCELLED: 'orderHistories.status.cancelled',
  REFUNDED: 'orderHistories.status.refunded',
  PARTIAL_REFUNDED: 'orderHistories.status.partialRefunded',
  PENDING_REFUND: 'orderHistories.status.pendingRefund',
  PENDING_PARTIAL_REFUND: 'orderHistories.status.pendingPartialRefund',
  MANUAL_PARTIAL_REFUND_PENDING: 'orderHistories.status.manualRefundPending',
  MANUAL_PARTIAL_REFUNDED: 'orderHistories.status.manualRefunded',
}

export const orderHistoryStatusOptions = Object.entries(statusTranslationKeys).map(
  ([value, translationKey]) => ({
    value,
    label: translate(translationKey),
  }),
)

export const formatOrderHistoryStatus = (status?: string) =>
  orderHistoryStatusOptions.find(option => option.value === status)?.label ?? status
